

export default function isPhone({ next, store, nextMiddleware }) {
  if (!store.GET_QUOTE.isVerify) {
    return next({
      name: "insurance.quote.phone",
    });
  }

  return nextMiddleware();
}
